import LabelMap from '../../types/label-map/LabelMap';
import __ from '../../i18n';

const STRAP_CROSS_SECTION_SHAPE_RECTANGLE = 'RECTANGLE';
const STRAP_CROSS_SECTION_SHAPE_CURVED = 'CURVED';
const STRAP_CROSS_SECTION_SHAPE_CURVED_SMALL = 'CURVED_SMALL';
const STRAP_CROSS_SECTION_SHAPE_CURVED_LARGE = 'CURVED_LARGE';
const STRAP_CROSS_SECTION_SHAPE_ROUNDED = 'ROUNDED';
const STRAP_CROSS_SECTION_SHAPE_ROUNDED_SMALL = 'ROUNDED_SMALL';
const STRAP_CROSS_SECTION_SHAPE_ROUNDED_LARGE = 'ROUNDED_LARGE';

const strapCrossSectionShapes = new LabelMap([
    [STRAP_CROSS_SECTION_SHAPE_RECTANGLE, __('Rectangle')],
    [STRAP_CROSS_SECTION_SHAPE_CURVED, __('Curved')],
    [STRAP_CROSS_SECTION_SHAPE_CURVED_SMALL, __('Small-curved')],
    [STRAP_CROSS_SECTION_SHAPE_CURVED_LARGE, __('Large-curved')],
    [STRAP_CROSS_SECTION_SHAPE_ROUNDED, __('Rounded')],
    [STRAP_CROSS_SECTION_SHAPE_ROUNDED_SMALL, __('Small-rounded')],
    [STRAP_CROSS_SECTION_SHAPE_ROUNDED_LARGE, __('Large-rounded')],
]);

export default strapCrossSectionShapes;

export {
    STRAP_CROSS_SECTION_SHAPE_RECTANGLE,
    STRAP_CROSS_SECTION_SHAPE_CURVED,
    STRAP_CROSS_SECTION_SHAPE_CURVED_SMALL,
    STRAP_CROSS_SECTION_SHAPE_CURVED_LARGE,
    STRAP_CROSS_SECTION_SHAPE_ROUNDED,
    STRAP_CROSS_SECTION_SHAPE_ROUNDED_SMALL,
    STRAP_CROSS_SECTION_SHAPE_ROUNDED_LARGE,
}
